const reuqestProtocol = "http://";
const baseDomain = "18.159.211.171";
const urlBase = `${reuqestProtocol}${baseDomain}/api`;

// AUTHENTICATION
export const POST_LOGIN = `${urlBase}/token/`;
export const POST_REGISTER = `${urlBase}/user-register/`;
export const POST_RESET_PASSWORD = `${urlBase}/reset-password/`;
